"use client";

import Link from "next/link";
import { Modal } from "./Modal";

interface AIAssistantModalProps {
  isOpen: boolean;
  onClose: () => void;
  entity: string; // e.g. "appointment", "repair"
  example?: string; // e.g. "Book Emma Torres for a private showing Thursday at 2pm"
}

export function AIAssistantModal({ isOpen, onClose, entity, example }: AIAssistantModalProps) {
  const fallbackExample = `Create a new ${entity} for me`;
  return (
    <Modal isOpen={isOpen} onClose={onClose} title={`New ${entity}`} size="md">
      <div className="space-y-5 py-1">
        <div className="flex items-center gap-3">
          <div className="flex h-10 w-10 items-center justify-center rounded-xl bg-gradient-to-br from-violet-400/25 to-indigo-500/10 ring-1 ring-violet-300/20">
            <svg className="h-5 w-5 text-violet-200" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth={1.8}>
              <path strokeLinecap="round" strokeLinejoin="round" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
            </svg>
          </div>
          <div>
            <p className="text-sm text-white font-medium">Create with RetailOS Assistant</p>
            <p className="text-xs text-muted">Fastest way to capture a new {entity}.</p>
          </div>
        </div>

        <div className="rounded-xl border border-white/10 bg-white/5 p-3">
          <p className="text-[10px] uppercase tracking-wider text-text-dim mb-1">Try saying or typing</p>
          <p className="text-sm text-white italic">&ldquo;{example || fallbackExample}&rdquo;</p>
        </div>

        <div className="flex items-center justify-end gap-2">
          <button
            type="button"
            onClick={onClose}
            className="rounded-xl border border-white/10 px-4 py-2 text-sm text-muted hover:bg-white/5 hover:text-white transition"
          >
            Close
          </button>
          <Link
            href="/dashboard/ai"
            className="rounded-xl bg-gradient-to-br from-violet-400 to-indigo-500 px-4 py-2 text-sm font-medium text-black hover:opacity-90 transition"
          >
            Open Assistant
          </Link>
        </div>
      </div>
    </Modal>
  );
}
